/*
    Видео с ютуба/вимео на странице
*/

class YoutubeVideo {
    constructor(el) {
        this.$container = $(el);
        this.$inner = this.$container.find('.js-video-inner');
        this.src = this.$container.data('url');

        this.active = false;

        this.bindClick();
    }



    bindClick() {
        if (!this.src) {
            return;
        }

        this.$inner.on('click', () => {

            // Если видео уже было запущено, ничего не делаем
            if (this.active) {
                return;
            }


            // Если это Youtube, формируем правильную ссылку
            if (this.src.indexOf('youtube.com/') !== -1 || this.src.indexOf('youtu.be/') !== -1) {
                const id = this.getYoutubeId(this.src);
                this.src = 'https://www.youtube.com/embed/' + id;
            }


            // Добавляем айфрейм с видео
            this.$inner.append(
                '<iframe src="' + this.src + '?title=0&byline=0&portrait=0&autoplay=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>'
            );

            this.$container.addClass('_active');
        });
    }


    getYoutubeId(url) {
        // Получаем правильный url для Youtube
        let ID = '';
        url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        } else {
            ID = url;
        }
        return ID;
    }
}


$('.js-video').each(function() {
    new YoutubeVideo(this);
});



// WEBPACK FOOTER //
// ./_src/js/modules/YoutubeVideo.js